import { render, staticRenderFns } from "./PortfolioSummaryReport.vue?vue&type=template&id=60cd1bbb&"
import script from "./PortfolioSummaryReport.vue?vue&type=script&lang=js&"
export * from "./PortfolioSummaryReport.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioSummaryReport.vue?vue&type=style&index=0&id=60cd1bbb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports